import { createApiClient } from '@telesafi/api-client';

// Single source of truth for the API base URL. Vite inlines this in both
// client and server bundles. Worker runtime gets it from `[vars]` /
// `process.env.VITE_API_URL` (populated via `nodejs_compat_populate_process_env`).
export const apiBaseUrl =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (import.meta as any).env?.VITE_API_URL ??
  process.env.VITE_API_URL ??
  process.env.INTERNAL_API_URL ??
  'http://localhost:30000';

export const apiSiteSlug = 'telesafi';

export const api = createApiClient({ baseUrl: apiBaseUrl, siteSlug: apiSiteSlug });
